<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>
            <h4 class="header-title">動画一覧</h4>
            <p class="sub-header">
              登録されている動画の一覧です。
            </p>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th></th>
                  <th>ID</th>
                  <th>表示順</th>
                  <th>タイトル</th>
                  <th>Vimeo ID</th>
                </tr>
              </thead>
              <draggable v-model="videoList" tag="tbody" :move="showSaveOrderBtn">
                <tr class="grabbing" v-for="video in videoList" :key="video.id">
                  <td><i class="fas fa-grip-lines"></i></td>
                  <td scope="row">#{{video.id}}</td>
                  <td>{{video.number}}</td>
                  <td>{{video.title}}</td>
                  <td>{{video.vimeo_id}}</td>
                </tr>
              </draggable>
            </table>
          </div>

          <button class="btn btn-primary btn-block" @click="saveOrder()" v-if="showBtn">並び順を保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      showBtn: false,
      organizationId: '',
      videoList: []
    };
  },
  methods: {
    async getVideo() {
      this.organizationId = window.location.href.split("/").slice(-3)[0]
      await this.axios.get(`/api/v1/admin/videos?organization_id=${this.organizationId}`).then((response) => {
        this.videoList = response.data
      }).catch((error) => {
      })
    },
    async saveOrder() {
      let params = {
        sortable_ids: this.videoList.map((video) => video.id),
        organization_id: this.organizationId
      }
      await this.axios.patch(`/api/v1/admin/organizations/${this.organizationId}/order/video`, params).then((response) => {
        this.$notify({
          group: "information",
          type: "success",
          title: "並び順を変更しました",
        });
        setTimeout(() => {
          window.location.href = `/admin/organizations/${this.organizationId}`
        }, 100)
      }).catch((error) => {
        this.$notify({
          group: "information",
          type: "error",
          title: error.response.data.err_message,
        });
      })
    },
    showSaveOrderBtn() {
      this.showBtn = true;
    }
  },
  mounted() {
    this.getVideo();
  }
};
</script>
